export default function Benefits() {
  const benefits = [
    {
      id: 1,
      icon: 'ri-flask-line',
      title: 'Formules naturelles',
      description: 'Des ingrédients soigneusement sélectionnés pour leur efficacité et leur douceur'
    },
    {
      id: 2,
      icon: 'ri-shield-check-line',
      title: 'Testé dermatologiquement',
      description: 'Tous nos produits sont testés sous contrôle dermatologique pour garantir leur sécurité'
    },
    {
      id: 3,
      icon: 'ri-leaf-line',
      title: 'Respectueux de l\'environnement',
      description: 'Emballages recyclables et formules biodégradables pour préserver notre planète'
    },
    {
      id: 4,
      icon: 'ri-heart-line',
      title: 'Non testé sur les animaux',
      description: 'Nous sommes fiers d\'être une marque cruelty-free certifiée'
    },
    {
      id: 5,
      icon: 'ri-star-line',
      title: 'Résultats visibles',
      description: 'Des effets prouvés dès la première application pour une peau transformée'
    },
    {
      id: 6,
      icon: 'ri-customer-service-line',
      title: 'Support expert',
      description: 'Notre équipe d\'esthéticiennes est à votre écoute pour vous conseiller'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        {/* Titre section */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-gray-900 mb-4">
            Pourquoi nous choisir
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Une expertise reconnue au service de votre beauté
          </p>
        </div>

        {/* Grille bénéfices */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit) => (
            <div key={benefit.id} className="text-center group">
              <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-[#E8B4A8]/10 flex items-center justify-center group-hover:bg-[#E8B4A8] transition-colors duration-300">
                <i className={`${benefit.icon} text-3xl text-[#E8B4A8] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
